import axios from 'axios'
import { ElMessage } from 'element-plus'
import { createSession } from '../api/index.ts'
import { loginRequest, loginResponse } from '@/api/webservice.ts'
// import { pinia1 } from '@/main.ts' // 导入已创建的 pinia 实例
// console.log('pinia', pinia1)
// import { useMainStore } from '@/stores/main.ts'
// const mainStore = useMainStore(pinia)

// console.log('mainStore --> index', mainStore)

async function calculateHash(text: string) {
  const hashBuffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text))
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  // console.log('hashHex', hashHex)
  return hashHex;
  // .then((hashBuffer) => {
  //   // 将ArrayBuffer转换为十六进制字符串
  //   const hashArray = Array.from(new Uint8Array(hashBuffer))
  //   const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  //   console.log('hashHex', hashHex)
  //   //   showResult(hashHex, "text-gray-800");
  // })
  // .catch((error) => {
  //   console.error('哈希计算错误:', error)
  //   //   showResult("计算失败，请重试", "text-red-600");
  // })
}


let sessionid = '';

const instance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASEURL_INFO,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
})

// # B_PubKey = b'123456'
//     ret = login_request({"subsys_id":MYID,"username":"lianyin"})
//     refinf = json.loads(ret)
//     req_time = refinf["request_time"]
//     challenge = refinf["challenge"]
//     password = '123456'
//     hasher = hashlib.sha256()
//     result = challenge.encode('utf-8')+password.encode('utf-8')
//     print("INPUT:%s"%result)
//     hasher.update(result)
//     response = hasher.hexdigest()
//     print("OUTPUT:%s"%response)
//     ret = login_response({"subsys_id":MYID,"request_time":req_time,"challenge":challenge,"response":response})
//     print(ret)
// 添加请求拦截器
instance.interceptors.request.use(
  async function (config) {
    const subsystemId = localStorage.getItem('subsystemId') || 1;
    if (!sessionid && config.url !== '/api/create_session') {
      const loginRequestRes = await loginRequest({
        username: 'Tbai',
        subsystem_id: subsystemId
      })
      // console.log('loginRequestRes', loginRequestRes)

      // const challengeHash = await calculateHash(loginRequestRes.data.challenge)
      // const passwordHash = await calculateHash('123456')
      // console.log('challengeHash', challengeHash)
      // console.log('passwordHash', passwordHash)
      const response = await calculateHash(loginRequestRes.data.challenge + '123456')
      // console.log('response', response)
      const loginResponseRes = await loginResponse({
        subsystem_id: subsystemId,
        request_time: loginRequestRes.data.request_time,
        challenge: loginRequestRes.data.challenge,
        // response: challengeHash + passwordHash,
        response: response,
      })
      console.log('loginResponseRes', loginResponseRes)
      const res = await createSession({
        subsystem_id: '1',
        login_time: loginResponseRes.data.login_time,
        login_token: loginResponseRes.data.login_token,
      })
      if (res.code === 0) {
        // localStorage.setItem('sessionid', res.sessionid)
        sessionid = res.data.sessionid
      }
    }
    if (sessionid) {
      if (config.url !== '/api/create_session') {
        config.data.sessionid = sessionid
      }
    }
    console.log(' config.data.',config.data)
    const arr = ['/api/create_session', '/api/start_segment', '/api/get_active_segment']
    // const arr = ['/api/create_session']
    if (!arr.includes(config.url as string)) {
      const segmentidInfo = localStorage.getItem('segmentidInfo')
      if (segmentidInfo) {
        config.data.segmentid = JSON.parse(segmentidInfo).segmentid
      }
    }

    // console.log('config', config)
    // 在发送请求之前做些什么
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  },
)

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    // console.log('response', response)
    if (response.data && response.data.code !== 0) {
      console.error(response)
      // ElMessage.error('请求错误 code: ' + response.data.code)
      // addMessages({
      //   type: 'info',
      //   msg: '请求错误 code: ' + response.data.code,
      // })
    }
    // console.log('response.data', response.data)
    return response.data
  },
  function (error) {
    // ElMessage.error('请求出错了 !', error)
    console.error('请求出错了 !', error)
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error)
  },
)
export default instance
